import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/magic-link-sent")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_public/magic-link-sent"!</div>;
}
